import el from "@cypherpotato/el";
import page from "page";
import { currentPath } from "../global-state";
import { getSession } from "../session";
import { Icon } from "./icon";

export function DashboardNavGroup(label) {
    return el("div.dashboard-nav-group", label);
}

export function DashboardNavItem(icon, label, href, extraText) {
    return el.state.listening([currentPath], () =>
        el("div.dashboard-nav-item",
            Icon(icon),
            el("span", label),
            {
                onMouseUp(event) {
                    if (event.button === 0) {
                        page(href);
                    } else if (event.button === 1) {
                        event.preventDefault();
                        window.open(href, "_blank");
                    }
                },
                init() {
                    if (currentPath.value.replace(/\/$/, "") === href) {
                        this.classList.add("active");
                    }
                }
            },
            extraText && el(".extra-texts", extraText)
        )
    );
}

export function DashboardExternalNavItem(icon, label, href) {
    return el.state.listening([currentPath], () =>
        el("div.dashboard-nav-item",
            Icon(icon),
            el("span", label, Icon("external-link-line")),
            {
                onClick() {
                    window.open(href, "_blank");
                }
            }
        )
    );
}

export function DashboardActionNavItem(icon, label, action) {
    return el.state.listening([currentPath], () =>
        el("div.dashboard-nav-item",
            Icon(icon),
            el("span", label),
            {
                onClick: action
            }
        )
    );
}

export function Dashboard(...children) {

    const session = getSession();

    return el("div.page-dashboard",
        el("aside",
            el("menu.logo-wrapper",
                el("img", { src: "/assets/compound-logo.svg" }),
                {
                    onClick() {
                        page("/dashboard");
                    }
                }
            ),
            el("menu.links-container",
                DashboardNavItem("home-2-line", "Home", "/dashboard"),

                DashboardNavGroup("Cloud AI"),
                DashboardNavItem("route-line", "AI Gateways", "/dashboard/ai-gateways"),
                DashboardNavItem("book-shelf-line", "RAG Collections", "/dashboard/collections"),
                DashboardNavItem("chat-1-line", "Chat clients", "/dashboard/chat-clients"),

                DashboardNavGroup("Management"),
                DashboardNavItem("user-settings-line", "Account", "/dashboard/account"),
            ),
            el("menu.bottom.links-container",
                DashboardExternalNavItem("git-repository-line", "Documentation", window.env.apiEndpoint + "apidocs"),
                DashboardExternalNavItem("github-fill", "GitHub", "https://github.com/"),
            )
        ),
        el('div.page-contents',
            el("header",
                el(".header-inner",
                    el(".account-container",
                        el(".account-info",
                            el("strong", session.data.name),
                            el("div", session.data.email)
                        ),
                        el(".account-avatar",
                            el("img", { src: `https://0.gravatar.com/avatar/${session.data.emailSha256}?size=128` })
                        ),
                        {
                            onClick() {
                                page("/dashboard/account")
                            }
                        },
                    ),
                )
            ),
            el("main",
                el(".main-contents",
                    ...children
                ),
                el("footer",
                    el(".footer-description",
                        el(".footer-item",
                            el("img[src=/assets/compound-logo.svg]",),
                            el("p",
                                "Compound hosts BYOK AI gateways, RAG collections and visual chat clients."
                            )
                        )
                    ),
                    el(".footer-row",
                        el("a", { href: window.env.apiEndpoint + "apidocs", target: "_blank" },
                            "Documentation"
                        )
                    )
                )
            )
        ),
    );
}

export function DashboardTitle(title, subtitle) {
    return el("div.dashboard-title",
        el("h1", title),
        el("p", subtitle)
    );
}
